import { render } from "./Home.vue?vue&type=template&id=670c33ea&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=670c33ea&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__